import HundredBricksAPIError from '../../HundredBricksAPIError';
class LeaseholdersError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('LeaseholdersError', ...args);
    }
}
export default LeaseholdersError;
